/**
 * Limites de tamanho de mídia da Meta (WhatsApp Cloud API).
 *
 * Espelha o back (limites-midia-whatsapp.util.ts). Existe no front para AVISAR o
 * usuário na hora de escolher o arquivo, em vez de deixar salvar e o envio falhar
 * em silêncio — foi o problema relatado: a mensagem aparecia como enviada e o
 * destinatário não recebia nada.
 */
const MB = 1024 * 1024;

export const LIMITES_MIDIA_META = {
  image: 5 * MB,
  audio: 16 * MB,
  video: 16 * MB,
  document: 100 * MB,
};

export const LIMITE_MIDIA_PADRAO = 5 * MB;

export function limiteDoTipo(tipo) {
  if (!tipo) return LIMITE_MIDIA_PADRAO;
  return LIMITES_MIDIA_META[String(tipo).toLowerCase()] ?? LIMITE_MIDIA_PADRAO;
}

export function formatarTamanho(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return '?';
  if (bytes >= MB) return `${(bytes / MB).toFixed(1)} MB`;
  if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${bytes} bytes`;
}

/**
 * Valida o tamanho de um arquivo contra o limite do seu tipo.
 * Retorna { ok, mensagem } — mensagem preenchida só quando estoura, pronta para
 * mostrar ao usuário, dizendo o tamanho, o limite e a consequência.
 */
export function validarTamanhoMidia(tipo, bytes) {
  const limite = limiteDoTipo(tipo);
  if (bytes == null || !Number.isFinite(bytes)) return { ok: true, limite };
  if (bytes > limite) {
    const nome = tipo ? String(tipo).toLowerCase() : 'mídia';
    return {
      ok: false,
      limite,
      mensagem:
        `A ${nome} tem ${formatarTamanho(bytes)} e o limite do WhatsApp é ` +
        `${formatarTamanho(limite)}. Reduza o arquivo — acima disso a Meta recusa ` +
        'o envio e o destinatário não recebe nada.',
    };
  }
  return { ok: true, limite };
}
